<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path d="M12.005 7.453a4.55 4.55 0 0 1 4.547 4.548c0 .591-.118 1.146-.327 1.664l2.655 2.656A10.747 10.747 0 0 0 22 12c-1.573-3.993-5.457-6.822-10.005-6.822-1.273 0-2.492.228-3.62.637L10.34 7.78a4.414 4.414 0 0 1 1.665-.328ZM2.909 4.97l2.074 2.074.419.418A10.736 10.736 0 0 0 2 12.001c1.573 3.992 5.457 6.821 10.005 6.821 1.41 0 2.755-.273 3.983-.764l.382.382 2.665 2.656 1.155-1.155L4.065 3.815 2.909 4.97ZM7.94 10l1.41 1.41a2.566 2.566 0 0 0-.073.59 2.725 2.725 0 0 0 2.729 2.73c.2 0 .4-.028.59-.074l1.41 1.41c-.609.3-1.282.482-2 .482a4.55 4.55 0 0 1-4.548-4.547c0-.719.182-1.392.482-2.001Zm3.92-.71 2.865 2.865.018-.145a2.725 2.725 0 0 0-2.728-2.729l-.155.01Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
